export type { ImageSrcSet, ImageProps } from './types'

export { default } from './Image'
